import LMSDispatcher from "../LMSDispatcher";
import { IApi, Api } from "../../utilities/Api";
import { ApiRequest } from "../../utilities/ApiRequest";
import * as ACTIONCONTANTS from "./ActionConstants";
import LogViewData, { ILogViewData } from "../../models/logs/LogViewData";

class LogActions {
  private readonly api: IApi;

  constructor() {
    this.api = new Api(ACTIONCONTANTS.LOG_ENDPOINT);
  }

  async getById(id: string) {
    try {
      const request = new ApiRequest("/logs/" + id, "", null, "Log not found.");
      const result = await this.api.get(request);

      const payload = this.convertResponseData(result.data);

      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.LOG_GET_BY_ID,
        payload: {
          sampleData: payload,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async getAll(
    from: string,
    to: string,
    isAll: boolean,
    page: number,
    pageSize: number,
    sort: string,
    order: string,
    filter: string
  ) {
    try {
      const request = new ApiRequest(
        `/logs/${from}/${to}/${isAll}/${page}/${pageSize}/${sort}/${order}/${filter}`,
        "",
        null,
        "Unable to fetch logs."
      );
      const result = await this.api.get(request);
      const payload = this.convertResponseListData(result.data);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.LOG_GET_ALL,
        payload: {
          logDataList: payload,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async getDateRange(from: any, to: any, requestId: any) {
    try {
      const payload: any = { from: from, to: to };
      const request = new ApiRequest(
        `/Report/GetTrendsDetail`,
        requestId,
        payload,
        "Internal server error!"
      );
      const result = await this.api.post(request);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.LOG_RANGE_REPORT,
        payload: {
          logDataList: result,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  private convertResponseData(data: any): ILogViewData {
    return new LogViewData(
      data.id,
      data.message,
      data.level,
      data.timeStamp,
      data.exception,
      data.userName,
      data.module
    );
  }

  private convertResponseListData(data: any) {
    const result: ILogViewData[] = [];
    if (data.contents) {
      data.contents.forEach(
        (element: {
          id: number;
          message: string;
          level: string;
          timeStamp: string;
          exception: string;
          userName: string;
          module: string;
        }) => {
          result.push(this.convertResponseData(element));
        }
      );
    } else {
      data.forEach(
        (element: {
          id: number;
          message: string;
          level: string;
          timeStamp: string;
          exception: string;
          userName: string;
          module: string;
        }) => {
          result.push(this.convertResponseData(element));
        }
      );
    }
    const tempResult = {
      result: data.contents ? result : result,
      currentPage: data.contents ? data.currentPage : 0,
      totalPages: data.contents ? data.totalPages : 0,
      totalRecords: data.contents ? data.totalRecords : 0,
    };
    return tempResult;
  }
}

const logActions = new LogActions();
export default logActions;
